import {useContext, useState} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {SalesRepTypeReportContext} from '../../context'
import Import from '../../../../images/Import.png'
import moment from 'moment'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import {MIN_DATE_RANGE, dataToSalesRepTypeShippingCSV} from '../../utils'

const SalesRepTypeReportsHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {onDateChange, salesRepTypeData} = useContext(SalesRepTypeReportContext)
  const [isLoading, setIsLoading] = useState(false)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToSalesRepTypeShippingCSV(salesRepTypeData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Discount_Report_Sales_Rep_Report_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex flex-wrap justify-content-end align-items-center mb-10 gap-5'>
      <button
        className='btn btn-outline'
        onClick={handleDownLoadCSV}
        disabled={isLoading || !salesRepTypeData?.length}
      >
        <div className='d-flex align-items-center'>
          <img src={Import} alt='Import File' className='me-2 import-icon' />
          <div className='d-flex align-items-center'>
            {isLoading ? 'Downloading...' : 'Export CSV'}
            {isLoading && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </div>
        </div>
      </button>
      <PredefinedDateRange
        cb={onDateChange}
        defaultValue={dateRangeLabel || 'Last 90 Days'}
        includeCurrantDay
        startDate={MIN_DATE_RANGE}
      />
    </div>
  )
}
export {SalesRepTypeReportsHeader}
